import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import customLogger from "../../utils/customLogger.js";

/**
 * ProtectedRoute component that checks if the user is authenticated
 * If not authenticated, redirects to the unauthorized page
 */
const ProtectedRoute = () => {
  const { isAuthenticated, token, checkAuth } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    // Force check authentication on mount and when location changes
    const isValid = checkAuth();
   // customLogger.log('ProtectedRoute auth check:', isValid);
    
    // You could add additional validation here if needed
  }, [checkAuth, location]);
  
  // If not authenticated, redirect to unauthorized page
  if (!isAuthenticated || !token) {
   // customLogger.log('Access denied: Not authenticated');
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  // If authenticated, render the child routes
  //customLogger.log('Access granted: User is authenticated');
  return <Outlet />;
};

export default ProtectedRoute;
